import {  legacy_createStore, combineReducers} from 'redux';

import user from '../reducers/users';
import app_details from "../reducers/app_details";
import offers from "../reducers/offers";
import event from "../reducers/deferredPrompt"
import version from "../reducers/version"
const rootReducer = combineReducers({
    user: user,
    appData: app_details,
    offers: offers,
    event: event,
    version: version
});

const configureStore = () => {
    return  legacy_createStore(rootReducer);
};

export default configureStore;